import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  linkTo?: string;
  className?: string;
}

export default function Logo({ size = 'md', showText = true, linkTo = '/', className = '' }: LogoProps) {
  const sizes = {
    sm: { icon: 'w-8 h-8', svg: 'w-5 h-5', text: 'text-lg' },
    md: { icon: 'w-10 h-10', svg: 'w-6 h-6', text: 'text-xl' },
    lg: { icon: 'w-12 h-12', svg: 'w-7 h-7', text: 'text-2xl' },
  };

  const { icon, svg, text } = sizes[size];

  const logoContent = (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${icon} rounded-xl bg-gradient-to-br from-coral-500 to-coral-600 flex items-center justify-center shadow-lg shadow-coral-200 dark:shadow-coral-900/30`}>
        <svg className={`${svg} text-white`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
        </svg>
      </div>
      {showText && (
        <span className={`${text} font-bold`}>
          <span className="bg-gradient-to-r from-coral-500 to-coral-600 bg-clip-text text-transparent">KoreanHub</span>
          <span className="text-gray-400">.net</span>
        </span>
      )}
    </div>
  );

  if (linkTo) {
    return <Link to={linkTo}>{logoContent}</Link>;
  }

  return logoContent;
}
